import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Image,
  Input,
  Loader,
  Tabs,
  MultiSelect,
  Paper,
  Select,
  SimpleGrid,
  Text,
  Textarea,
  TextInput,
  NumberInput,
} from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { getListUsers } from "../../../services/users";
import { getAllCountryList } from "../../../services/location";
import { IconCheck, IconPhotoPlus } from "@tabler/icons-react";
import { getAllSupplierList } from "../../../services/supplier";
import { Dropzone } from "@mantine/dropzone";
import NoImage from "../../../assets/img/images/no-images.png";
import { addBrand, updateBrand, uploadImage } from "../../../services/brands";
import { notificationError, notificationSuccess } from "../../ui/Notifications";
import LoadingData from "../../ui/LoadingData";
import { useIsFirstRender } from "@mantine/hooks";
import { useBrandForm } from "./schema/form";
import { CURRENCIES } from "../../../helper/master-unit";

const defaultStatus = [
  {
    label: "Active",
    value: "true",
  },
  {
    label: "Inactive",
    value: "false",
  },
];

const FormBrands = ({ dataBrand, onCloseModal, reloadList }) => {
  const form = useBrandForm();
  const [userList, setUserList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [mainSupplierList, setMainSupplierList] = useState([]);
  const [subSupplierList, setSubSupplierList] = useState([]);
  const [storeRecentSubSupplier, setStoreRecentSubSupplier] = useState([]);

  const [loadingForm, setLoadingForm] = useState(false);
  const [loadingUser, setLoadingUser] = useState(true);
  const [loadingCountry, setLoadingCountry] = useState(true);
  const [loadingMainSupplier, setLoadingMainSupplier] = useState(true);
  const [loadingSubSupplier, setLoadingSubSupplier] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(true);

  const [searchUser, setSearchUser] = useState("");
  const [searchMainSupplier, setSearchMainSupplier] = useState("");
  const [searchSubSupplier, setSearchSubSupplier] = useState("");

  const [imageUpload, setImageUpload] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [recentImage, setRecentImage] = useState(null);
  const [selectedTab, setSelectedTab] = useState("form");
  const renderedData = useIsFirstRender();

  const handleGetListUsers = useDebouncedCallback(async (userId) => {
    setLoadingUser(true);
    const parameter = {
      "filter[id][is]": userId,
      "filter[name][like]": searchUser,
      "fields[user]": "id,name,email,active",
      "page[num]": 1,
      "page[limit]": 8,
      sort: "-created_at",
      active: true,
    };

    try {
      const response = await getListUsers(parameter);
      const dataUser = response.data.data;
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email,
        };
      });
      setUserList(remapDataUser);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUser(false);
    }
  }, 300);

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true);
    const parameter = {
      "page[num]": 1,
      "page[limit]": 9999,
      "fields[country]": "name",
    };
    try {
      const response = await getAllCountryList(parameter);
      const dataCountry = response.data;
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });
      setCountryList(remapDataCountry);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCountry(false);
    }
  }, 300);

  const handleGetListMainSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingMainSupplier(true);
    const parameter = {
      "filter[id][is]": supplierId,
      "filter[name][like]": searchMainSupplier,
      "page[num]": 1,
      "page[limit]": 10, // bad habbit
      "fields[supplier]": "name",
    };

    try {
      const response = await getAllSupplierList(parameter);
      const dataSuppliers = response.data;
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });
      setMainSupplierList(remapDataSuppliers);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingMainSupplier(false);
    }
  }, 300);

  const handleGetListSubSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSubSupplier(true);
    const parameter = {
      "filter[id][is]": supplierId,
      "filter[name][like]": searchSubSupplier,
      "page[num]": 1,
      "page[limit]": 10, // bad habbit
      "fields[supplier]": "name",
    };

    try {
      const response = await getAllSupplierList(parameter);
      const dataSuppliers = response.data;
      let dataSubSupplier = [];
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        };
      });

      if (storeRecentSubSupplier.length > 0) {
        const joinData = remapDataSuppliers.concat(storeRecentSubSupplier);
        const findDuplicate = joinData.reduce((result, item) => {
          const removed = result.filter((val) => val.value !== item.value);
          return [...removed, item];
        }, []);
        dataSubSupplier = findDuplicate;
      } else {
        dataSubSupplier = remapDataSuppliers;
      }

      setSubSupplierList(dataSubSupplier);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSubSupplier(false);
    }
  }, 300);

  const handleUploadImage = (file) => {
    const fileEncoded = file[0];
    const fileReader = new FileReader();
    fileReader.readAsDataURL(fileEncoded);
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result);
      setImageFile(fileEncoded);
    };
  };

  const handleErrorFile = (file) => {
    const fileState = Object.values(file);
    const errorMessage = fileState[0].errors[0].message;
    if (errorMessage) {
      notificationError("Upload Logo Brand Error", `${errorMessage}`);
    }
  };

  const handleSelectedImage = () => {
    return imageUpload || recentImage || NoImage;
  };

  // submit data
  const submitBrand = async (payloadForm) => {
    setLoadingForm(true);
    let methodFunction = null;
    let titleMessageSuccess = "";
    let captionMessageSuccess = "";
    let titleMessageError = "";
    let captionMessageError = "";

    if (dataBrand === null) {
      methodFunction = addBrand(payloadForm);
      titleMessageSuccess = "Add Brand Successfully";
      captionMessageSuccess = "You have been added new Brand";
      titleMessageError = "Add Brand Error";
    } else {
      methodFunction = updateBrand(dataBrand.id, payloadForm);
      titleMessageSuccess = "Update Brand Successfully";
      captionMessageSuccess = "You have been updated data Brand";
      titleMessageError = "Update Brand Error";
    }

    // helper
    const _onSuccess = () => {
      onCloseModal();
      reloadList();
      notificationSuccess(titleMessageSuccess, captionMessageSuccess);
    };

    try {
      const response = await methodFunction;
      if (response.success) {
        const { id } = response.data;

        // image submit
        if (imageFile) {
          const data = new FormData();
          data.append("logo", imageFile);
          await uploadImage(id, data);
          _onSuccess();
        } else {
          _onSuccess();
        }
      }
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.message;
      captionMessageError = Object.keys(errorMessage)
        ? errorMessage
        : "Please recheck your form";
      notificationError(titleMessageError, captionMessageError);
    } finally {
      setLoadingForm(false);
    }
  };

  useEffect(() => {
    handleGetListUsers();
    // eslint-disable-next-line
  }, [searchUser]);

  useEffect(() => {
    handleGetListMainSupplier();
    // eslint-disable-next-line
  }, [searchMainSupplier]);

  useEffect(() => {
    handleGetListSubSupplier();
    // eslint-disable-next-line
  }, [searchSubSupplier]);

  useEffect(() => {
    // handleGetListSupplier()
    handleGetListCountry();
    if (dataBrand) {
      handleSetForm(dataBrand);
    } else {
      setLoadingDetail(false);
    }
    // eslint-disable-next-line
  }, [dataBrand, renderedData]);

  const handleChangeFormNoSpace = (name, val) => {
    form.setValues((prev) => ({ ...prev, [name]: val.trim() }));
  };

  const handleSelectSubSupplier = (valueSupplier) => {
    const selectedSubSupplier = subSupplierList.find((val) => {
      return val.value === `${valueSupplier}`;
    });
    if (selectedSubSupplier) {
      setStoreRecentSubSupplier((oldVal) => [...oldVal, selectedSubSupplier]);
      form.insertListItem("sub_supplier_id", valueSupplier);
    }
  };

  const handleRemoveSubSupplier = (valueSupplier) => {
    const unselectSubSupplier = storeRecentSubSupplier.filter((val) => {
      return val.value !== `${valueSupplier}`;
    });
    setStoreRecentSubSupplier(unselectSubSupplier);
    form.removeListItem("sub_supplier_id", valueSupplier);
  };

  const handleSetForm = async (value) => {
    console.log(value);
    setLoadingDetail(true);
    const dataSupplier = value.suppliers;
    const getMainSupplier = dataSupplier.find((val) => val.is_primary);
    const getSubSupplier = dataSupplier.filter((val) => !val.is_primary);
    if (value.user_id !== null) {
      await handleGetListUsers(value.user_id);
    }
    if (getMainSupplier) {
      await handleGetListMainSupplier(getMainSupplier.id);
    }
    if (getSubSupplier.length > 0) {
      const remapData = getSubSupplier.map((val) => {
        return {
          value: `${val.id}`,
          label: val.name,
        };
      });
      setStoreRecentSubSupplier(remapData);
    }
    if (value.image_url) {
      setRecentImage(value.image_url);
    }
    console.log("status", value.status);
    const dataDetail = {
      id: value.id,
      name: value.name,
      website: value.website,
      country_id: `${value.country_id}`,
      description: value.description || "",
      slug: value.slug,
      user_id: value.user_id !== null ? `${value.user_id}` : null,
      main_supplier_id: getMainSupplier ? `${getMainSupplier.id}` : null,
      sub_supplier_id:
        getSubSupplier.length > 0
          ? getSubSupplier.map((val) => `${val.id}`)
          : [],
      active: value.status ? "true" : "false",
      featured: value.featured,
      principal_brand: value.principal_brand,
      is_import: value.is_import,
      is_partnered: value.is_partnered,
      open_distributor_country: value.open_distributor_country.map(
        (e) => `${e.id}`,
      ),
      priority: value.priority,
      export_minimum_value: value.export_minimum_value
        ? Number(value.export_minimum_value)
        : 0,
      export_currency: value.export_currency
        ? value.export_currency.toUpperCase()
        : "",
    };
    form.initialize(dataDetail);
    form.setValues(dataDetail);
    // setFormData(dataDetail)
    if (!renderedData) {
      setLoadingDetail(false);
    }
  };

  const loadingDataTemplate = () => {
    return (
      <Box ta="center" my={12}>
        <Loader size={16} />
        <Text c="gray.6" fz={11}>
          Loading Data
        </Text>
      </Box>
    );
  };

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align="center" gap="xs">
        <Flex gap="sm" align="center">
          <Avatar
            variant="filled"
            name={option.label}
            radius="xl"
            size="sm"
            color="red"
          />
          <Box>
            <Text fz={12} fw="600" lineClamp={2}>
              {option.label}
            </Text>
            <Text fz={10} fw="500" c="gray.6" lineClamp={2}>
              {option.email}
            </Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
      </Group>
    );
  };

  const mappingFormBrand = () => {
    const mappingFormDistributorCountry = (principal) => {
      if (principal) {
        return (
          <Box mb="md" pos="relative">
            <MultiSelect
              name="open_distributor_country"
              label="Open Distribution Country"
              description={
                <Box>
                  <Text fz={10} color="dimmed">
                    As a Principal Brand, please select the countries where you
                    want this brand to be distributed.{" "}
                  </Text>
                  <Text fz={10} color="dimmed">
                    (The brand will be visible to users from the selected
                    countries.)
                  </Text>
                </Box>
              }
              size="xs"
              key={form.key("open_distributor_country")}
              {...form.getInputProps("open_distributor_country")}
              searchable
              data={countryList}
              clearable
              hidePickedOptions
              withAsterisk
            />
          </Box>
        );
      }
    };
    return (
      <Box>
        <Box mih={550}>
          <Tabs size="xs" my={4} value={selectedTab} onChange={setSelectedTab}>
            <Tabs.List>
              <Tabs.Tab value="form">Brand</Tabs.Tab>
              <Tabs.Tab value="photo">Logo Brand</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="form">
              <Box my={10}>
                <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
                  <Box>
                    <TextInput
                      name="name"
                      label="Name Brand"
                      key={form.key("name")}
                      {...form.getInputProps("name")}
                      withAsterisk
                      size="xs"
                    />
                  </Box>

                  <Box>
                    <TextInput
                      name="slug"
                      label="Brand URL Slug"
                      {...form.getInputProps("slug")}
                      onChange={(val) =>
                        handleChangeFormNoSpace("slug", val.target.value)
                      }
                      withAsterisk
                      size="xs"
                    />
                  </Box>

                  <Box>
                    <Select
                      name="country_id"
                      label="Select Country"
                      data={countryList}
                      key={form.key("country_id")}
                      {...form.getInputProps("country_id")}
                      size="xs"
                      searchable
                      nothingFoundMessage={
                        !loadingCountry
                          ? countryList.length > 0
                            ? ""
                            : "No Country Found"
                          : loadingDataTemplate()
                      }
                      clearable
                      withAsterisk
                    />
                  </Box>

                  <Box>
                    <TextInput
                      name="website"
                      label="Website"
                      key={form.key("website")}
                      {...form.getInputProps("website")}
                      size="xs"
                    />
                  </Box>
                </SimpleGrid>

                <Box mb="sm">
                  <Textarea
                    name="description"
                    label="Description"
                    placeholder="Input description"
                    key={form.key("description")}
                    {...form.getInputProps("description")}
                    size="xs"
                    autosize
                    minRows={4}
                    maxRows={4}
                    withAsterisk
                  />
                </Box>

                <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
                  <Select
                    name="active"
                    label="Status"
                    data={defaultStatus}
                    key={form.key("active")}
                    {...form.getInputProps("active")}
                    size="xs"
                    allowDeselect={false}
                  />

                  <NumberInput
                    label="Priority Number"
                    key={form.key("priority")}
                    {...form.getInputProps("priority")}
                    clampBehavior="strict"
                    min={0}
                    max={100}
                    size="xs"
                    withAsterisk
                  />
                </SimpleGrid>

                <SimpleGrid cols={2} verticalSpacing="sm" mb="sm">
                  <Select
                    name="export_currency"
                    label="Export Currency"
                    data={CURRENCIES}
                    key={form.key("export_currency")}
                    {...form.getInputProps("export_currency")}
                    size="xs"
                    placeholder="Select Currency"
                    searchable
                    clearable
                  />
                  <NumberInput
                    prefix={form.values.export_currency + " "}
                    label="Export Minimum Value"
                    prio
                    key={form.key("export_minimum_value")}
                    {...form.getInputProps("export_minimum_value")}
                    min={0}
                    thousandSeparator="."
                    decimalSeparator=","
                    size="xs"
                  />
                </SimpleGrid>
                <Box my="lg">
                  <SimpleGrid cols={4} verticalSpacing="sm" mb="sm">
                    <Checkbox
                      labelPosition="right"
                      size="xs"
                      label="Imported Brand"
                      key={form.key("is_import")}
                      {...form.getInputProps("is_import", { type: "checkbox" })}
                    />
                    <Checkbox
                      labelPosition="right"
                      size="xs"
                      label="Partnered Brand"
                      key={form.key("is_partnered")}
                      {...form.getInputProps("is_partnered", {
                        type: "checkbox",
                      })}
                    />
                    <Checkbox
                      labelPosition="right"
                      size="xs"
                      label="Featured Brand"
                      key={form.key("featured")}
                      {...form.getInputProps("featured", { type: "checkbox" })}
                    />
                    <Checkbox
                      labelPosition="right"
                      size="xs"
                      label="Principal Brand"
                      key={form.key("principal_brand")}
                      {...form.getInputProps("principal_brand", {
                        type: "checkbox",
                      })}
                    />
                  </SimpleGrid>
                </Box>

                {mappingFormDistributorCountry(
                  form.getValues().principal_brand,
                )}

                <Box my="md">
                  <Select
                    name="user_id"
                    label="Brand Admin"
                    data={userList}
                    renderOption={renderUserOption}
                    key={form.key("user_id")}
                    {...form.getInputProps("user_id")}
                    size="xs"
                    searchable
                    searchValue={searchUser}
                    onSearchChange={setSearchUser}
                    nothingFoundMessage={
                      !loadingUser
                        ? userList.length > 0
                          ? ""
                          : "No User Found"
                        : loadingDataTemplate()
                    }
                    clearable
                    allowDeselect={false}
                  />
                </Box>

                <Box mb="md">
                  <Select
                    name="main_supplier_id"
                    label="Main Store"
                    data={mainSupplierList}
                    key={form.key("main_supplier_id")}
                    {...form.getInputProps("main_supplier_id")}
                    size="xs"
                    searchable
                    searchValue={searchMainSupplier}
                    onSearchChange={setSearchMainSupplier}
                    nothingFoundMessage={
                      !loadingMainSupplier
                        ? mainSupplierList.length > 0
                          ? ""
                          : "No Supplier Found"
                        : loadingDataTemplate()
                    }
                    clearable
                    allowDeselect={false}
                  />
                </Box>

                <Box mb="md">
                  <MultiSelect
                    name="sub_supplier_id"
                    label="Sub Store"
                    size="xs"
                    {...form.getInputProps("sub_supplier_id")}
                    onOptionSubmit={(val) => handleSelectSubSupplier(val)}
                    onRemove={(val) => handleRemoveSubSupplier(val)}
                    searchable
                    clearable
                    data={subSupplierList}
                    searchValue={searchSubSupplier}
                    onSearchChange={setSearchSubSupplier}
                    nothingFoundMessage={
                      !loadingSubSupplier
                        ? subSupplierList.length > 0
                          ? ""
                          : "No Supplier Found"
                        : loadingDataTemplate()
                    }
                    hidePickedOptions
                  />
                </Box>
              </Box>
            </Tabs.Panel>
            <Tabs.Panel value="photo">
              <Box my={10}>
                <Box>
                  <Input.Wrapper label="Upload Logo Brand (Optional)" size="xs">
                    <Box my={10}>
                      <Dropzone
                        accept={["image/png", "image/jpeg", "image/gif"]}
                        onDrop={(files) => handleUploadImage(files)}
                        onReject={(files) => handleErrorFile(files)}
                        maxSize={2000000}
                      >
                        <Box ta="center" my={15}>
                          <Flex justify="center" mb={10}>
                            <IconPhotoPlus size={50} color="gray" />
                          </Flex>
                          <Box>
                            <Text fz={12} c="blue.9">
                              Upload Image Here
                            </Text>
                            <Text fz={12} c="gray.6">
                              PNG, JPG, GIF up to 2 MB
                            </Text>
                          </Box>
                        </Box>
                      </Dropzone>
                    </Box>
                  </Input.Wrapper>
                </Box>
                <Box>
                  <Text fz={12} fw="500" mb={10}>
                    Recent / Review Logo
                  </Text>
                  <Paper
                    shadow="sm"
                    withBorder
                    radius="md"
                    style={{ backgroundColor: "#f1f2f5" }}
                  >
                    <Flex justify="center">
                      <Image
                        src={handleSelectedImage()}
                        w="auto"
                        radius="md"
                        h={250}
                        fit="contain"
                      />
                    </Flex>
                  </Paper>
                </Box>
              </Box>
            </Tabs.Panel>
          </Tabs>
        </Box>
        <Box mt={20}>
          <Flex justify="flex-end">
            <Group>
              <Button size="xs" variant="outline" onClick={onCloseModal}>
                Close
              </Button>
              <Button
                size="xs"
                loading={loadingForm}
                variant="filled"
                onClick={form.onSubmit((value) => submitBrand(value))}
              >
                {dataBrand !== null ? "Update" : "Create"}
              </Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    );
  };

  return <Box>{loadingDetail ? <LoadingData /> : mappingFormBrand()}</Box>;
};

export default FormBrands;
